import { motion } from 'framer-motion'
import { QrCode, Smartphone, Scan } from 'lucide-react'

export function HomeTraceability() {
  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              产品溯源功能
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              通过微信扫码即可查看产品的详细溯源信息，包括原材料来源、生产过程、检验报告等，让食品安全看得见、摸得着。
            </p>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Scan className="w-6 h-6 text-primary-500" />
                </div>
                <div>
                  <h4 className="text-lg font-medium mb-2">扫码溯源</h4>
                  <p className="text-gray-600">通过微信扫码进入小程序，查看产品详细信息</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <QrCode className="w-6 h-6 text-primary-500" />
                </div>
                <div>
                  <h4 className="text-lg font-medium mb-2">全程追溯</h4>
                  <p className="text-gray-600">从原材料采购到成品配送，每一个环节都可追溯</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Smartphone className="w-6 h-6 text-primary-500" />
                </div>
                <div>
                  <h4 className="text-lg font-medium mb-2">便捷查看</h4>
                  <p className="text-gray-600">随时随地通过手机查看产品溯源信息</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
              <div className="w-64 h-64 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-6">
                {/* <QrCode className="w-48 h-48 text-gray-400" /> */}
                <img src="/images/wechat_code_2x.jpg" alt="traceability-qrcode" className="w-48 h-48" />
              </div>
              <h4 className="text-lg font-medium mb-2">扫码查看溯源</h4>
              <p className="text-gray-600 text-sm">微信扫一扫，即可查看产品详细信息</p>
            </div>
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center animate-pulse-slow" />
            <div className="absolute -bottom-6 -left-6 w-16 h-16 bg-primary-200 rounded-full flex items-center justify-center animate-bounce-slow" />
          </motion.div>
        </div>
      </div>
    </section>
  )
}
